import { NgModule } from '@angular/core';
import { CustomUserEventBuilder } from "./custom-user-event.builder";



@NgModule({})
export class CustomUserEventModule {
  constructor(_customUserEventBuilder: CustomUserEventBuilder) {
    // Intentional empty constructor
  }
}
